import { useMe } from '../auth/useMe';
import { canManageSettings } from './access';
import { StageTypesSettings } from '../schedule/StageTypesSettings';
import { ChecklistPresetsSettings } from './ChecklistPresetsSettings';
import { ExportSettings } from './ExportSettings';
import { BoxSettings } from './BoxSettings';
import { GusSettings } from './GusSettings';
import { RepeatSettings } from '../company-tasks/RepeatSettings';
import { SystemsSettings } from './SystemsSettings';
import { NewEventPlaceSettings } from './NewEventPlaceSettings';
import { VenuesSettings } from './VenuesSettings';
import { WarehouseSettings } from './WarehouseSettings';
import './settings.css';

/**
 * "Ustawienia firmy" (Administracja): the lists and preferences that features use. Each of them also opens from
 * a small gear at its place of use (rule 9 of docs/wyglad.md).
 */
export function SettingsPage() {
  const { me } = useMe();
  if (!me) return null;
  return (
    <section className="page narrow settings-page" data-feature-id="events.settings">
      <h1>Ustawienia firmy</h1>
      <p className="muted">Listy i preferencje używane przy wydarzeniach. Każdą z nich otworzysz też trybikiem ⚙ w miejscu, gdzie jej używasz.</p>
      {!canManageSettings(me).any && <p className="notice">Nie masz uprawnień do zmiany ustawień firmy.</p>}
      {canManageSettings(me).warehouse && <WarehouseSettings me={me} />}
      {/* owner 2026-10-30 22:20 / 22:23: the default place and „Skojarzenia miejsc”, the same right as the warehouse */}
      {canManageSettings(me).warehouse && <NewEventPlaceSettings me={me} />}
      {canManageSettings(me).venues && <VenuesSettings me={me} />}
      {canManageSettings(me).systems && <SystemsSettings me={me} />}
      {canManageSettings(me).checklists && <ChecklistPresetsSettings me={me} />}
      {canManageSettings(me).stageTypes && <StageTypesSettings me={me} />}
      {canManageSettings(me).taskRepeats && <RepeatSettings me={me} />}
      {canManageSettings(me).exports && <ExportSettings me={me} />}
      {canManageSettings(me).gus && <GusSettings />}
      {canManageSettings(me).box && <BoxSettings />}
    </section>
  );
}
